import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import each from 'lodash/each';

import styles from '../styles/uikitGridsColumn.module.scss';

const Column = ({ children, className = '', sizes = null, testId = '' }) => {
  const sizeClasses = [];
  if (sizes) {
    each(sizes, (value, key) => {
      const keyCap = key.charAt(0).toUpperCase()
        + key.slice(1).toLowerCase();

      if (key === 'default' && value === 'auto') {
        sizeClasses.push(`${styles.isColAuto}`);
      } else if (key === 'default') {
        sizeClasses.push(`${styles[`isCol${value}`]}`);
      } else if (value === 'auto') {
        sizeClasses.push(`${styles[`isCol${keyCap}Auto`]}`);
      } else {
        sizeClasses.push(`${styles[`isCol${keyCap}${value}`]}`);
      }
    });
  }

  return (
    <div
      className={classnames(
        styles.element,
        sizeClasses,
        className,
      )}
      data-testid={testId}
    >
      {children}
    </div>
  );
};

Column.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  sizes: PropTypes.shape({}),
  testId: PropTypes.string,
};

export default React.memo(Column);
